import { StyledMapModal } from './MapModal.styled';
import { AppModal } from '../';

const MapModal = ({ src }) => {
  return (
    <AppModal>
      <StyledMapModal>
        <img className='map-modal-image' src={src} />
      </StyledMapModal>
    </AppModal>
  );
};

export default MapModal;
